import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Grid, Card, CardContent, Divider, Typography, Tooltip } from '@material-ui/core';

import { getEliteStatus, renderWheelInfo, renderTeams } from './statistics/gameStatistics';
import ironUmp from '../assets/ironUmp.svg';

const styles = {
  card: {
    minWidth: 280,
    height: 240,
    padding: 2,
    justifyContent: 'space-around',
    alignItems: 'flex-start'
  },
  box: {
    padding: 2,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#eeeeee'
  },
  icon: {
    marginLeft: 6,
    height: 24
  }
};

class UserStatistics extends PureComponent {

  componentDidMount() {
    const { userSeason, memberId, getUmpireStats, getTeamsVolunteering } = this.props;
    if (userSeason) {
      getUmpireStats(userSeason, memberId);
      getTeamsVolunteering(memberId, userSeason);
    }
  }

  componentDidUpdate(prevProps) {
    const { userSeason, memberId, getUmpireStats, getTeamsVolunteering } = this.props;
    if (userSeason !== prevProps.userSeason) {
      getUmpireStats(userSeason, memberId);
      getTeamsVolunteering(memberId, userSeason);
    }
  }
  
  render() {
    const { umpireLevel, umpireStats, fetchingUmpireStatsStatus, teamsVolunteering, teamsVolunteeringStatus } = this.props;
    const { classes } = this.props;

    if (fetchingUmpireStatsStatus === 'Loaded' && teamsVolunteeringStatus === 'Loaded') {

      const gameTotal = umpireStats.plateTotal + umpireStats.baseTotal;
      const eliteStatus = getEliteStatus(gameTotal);
    
      return (
        <Card className={classes.card} >
          <CardContent>
            <Typography align="left" variant="h6">
              My Statistics
              {umpireStats.isIronUmp && <Tooltip title="Iron Ump"><img src={ironUmp} alt="Iron Ump" className={classes.icon}/></Tooltip>}
            </Typography>
          </CardContent>
          <Divider/>
          <CardContent padding={2}>
            <Grid container spacing={8}>
                <Grid item xs={4}>
                  <div className={classes.box}>
                    <Typography align="center" color="textSecondary">
                      Level
                    </Typography>
                    <Typography align="center" variant="h4" component="h2">
                      {umpireLevel}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className={classes.box}>
                    <Typography align="center" color="textSecondary">
                      Teams Rep.
                    </Typography>
                    {renderTeams(teamsVolunteering)}
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className={classes.box}>
                    <Typography align="center" color="textSecondary">
                      Wheel
                    </Typography>
                    {renderWheelInfo(umpireStats)}
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className={classes.box}>
                    <Typography align="center" color="textSecondary">
                      Completed
                    </Typography>
                    <Typography align="center" variant="h4" component="h2">
                      {gameTotal}
                      {eliteStatus.icon && <Tooltip title={eliteStatus.title}><img src={eliteStatus.icon} alt={eliteStatus.title} className={classes.icon}/></Tooltip>}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className={classes.box}>
                    <Typography align="center" color="textSecondary">
                      @ Plate
                    </Typography>
                    <Typography align="center" variant="h4" component="h2">
                      {umpireStats.plateTotal}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className={classes.box}>
                    <Typography align="center" color="textSecondary">
                      @ Base
                    </Typography>
                    <Typography align="center" variant="h4" component="h2">
                      {umpireStats.baseTotal}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
          </CardContent>
        </Card>
      );
    } else {
      return (
        <Card className={classes.card} >
          <CardContent>
            <Typography align="left" variant="h6">
              My Statistics
            </Typography>
          </CardContent>
          <Divider/>
          <CardContent>
            <Typography align="center" color="textSecondary">
              Loading Statistics...
            </Typography>
          </CardContent>
        </Card>
      );
    }
  }
}

UserStatistics.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UserStatistics);



// WEBPACK FOOTER //
// ./src/components/UserStatistics.js